import Vue from 'vue';
import Router from 'vue-router';


// General
import login from '../javascripts/components/login/login.vue';
import register from '../javascripts/components/register/register.vue';
import resetPassword from '../javascripts/components/reset-password/resetPassword.vue';
import resetPasswordEmail from '../javascripts/components/reset-password/resetPasswordEmail.vue';
import pageNotFound from '../javascripts/components/pageNotFind.vue';

// // Modules
import metrics from '../javascripts/modules/metrics/metrics.vue';
import profile from '../javascripts/modules/profile/profile.vue';
import integrations from '../javascripts/modules/integrations/integrations.vue';
import knowledges from '../javascripts/modules/entity/knowledges.vue';
import knowledgeDetails from '../javascripts/modules/entity/knowledgeDetails.vue';
import intentsDetails from '../javascripts/modules/entity/intentsDetails.vue';
import polls from '../javascripts/modules/poll/polls.vue';
import pollsDetails from '../javascripts/modules/poll/pollsDetails.vue';
import pollsRevision from '../javascripts/modules/poll/pollsRevision.vue';
import groupsDetails from '../javascripts/modules/group/groupsDetails.vue';
import inbox from '../javascripts/modules/issue/inbox.vue';
import repliedMessages from '../javascripts/modules/issue/repliedMessages.vue';
import ignoredMessages from '../javascripts/modules/issue/ignoredMessages.vue';
import messageDetails from '../javascripts/modules/issue/messageDetails.vue';
import campaigns from '../javascripts/modules/campaign/campaigns.vue';
import campaignsDetails from '../javascripts/modules/campaign/campaignsDetails.vue';
import supporters from '../javascripts/modules/recipient/supporters.vue';
import supportersDetails from '../javascripts/modules/recipient/supportersDetails.vue';
import tickets from '../javascripts/modules/tickets/tickets.vue';
import ticketDetails from '../javascripts/modules/tickets/ticketDetails.vue';
import log from '../javascripts/modules/log/log.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '/',
			name: 'login',
			component: login,
		},
		{
			path: '/cadastro',
			name: 'register',
			component: register,
		},
		{
			path: '/reset-password/:token',
			name: 'resetpassword',
			component: resetPassword,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '/reset-password-email',
			name: 'resetpasswordemail',
			component: resetPasswordEmail,
			meta: {
				requiresAuth: false,
			},
		},
		{
			path: '*',
			component: pageNotFound,
		},
		{
			path: '/indicadores',
			name: 'metrics',
			component: metrics,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/configuracoes',
			name: 'profile',
			component: profile,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/engajamento/enviados',
			name: 'polls',
			component: polls,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/engajamento/enviar-enquete/revisao/:id',
			name: 'pollsRevision',
			component: pollsRevision,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/engajamento/enviar-enquete',
			name: 'pollsDetails',
			component: pollsDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/chamados',
			name: 'tickets',
			component: tickets,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/chamados/:ticketId',
			name: 'ticketDetails',
			component: ticketDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/mensagens/caixa-de-entrada',
			name: 'inbox',
			component: inbox,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/mensagens/respondidas',
			name: 'repliedMessages',
			component: repliedMessages,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/mensagens/lixeira',
			name: 'ignoredMessages',
			component: ignoredMessages,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/mensagens/:id',
			name: 'messageDetails',
			component: messageDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/dialogflow/intencoes',
			name: 'knowledges',
			component: knowledges,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/dialogflow/intencao',
			name: 'knowledgeDetails',
			component: knowledgeDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/engajamento/enviar-mensagen',
			name: 'campaignsDetails',
			component: campaignsDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/campanhas',
			name: 'campaigns',
			component: campaigns,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/seguidores',
			query: {
				page: 1,
			},
			name: 'supporters',
			component: supporters,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/seguidor',
			name: 'supportersDetails',
			component: supportersDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/integracoes',
			name: 'integrations',
			component: integrations,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/logs/registro-de-atividades',
			name: 'log',
			component: log,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/tema/:id',
			name: 'intentsDetails',
			component: intentsDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/grupos/duplicar/:id',
			name: 'duplicateGroups',
			component: groupsDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/grupos/editar/:id',
			name: 'editGroups',
			component: groupsDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/segmentacao/criar-grupos',
			name: 'createGroups',
			component: groupsDetails,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/segmentacao/meus-grupos',
			name: 'groups',
			component: groupsDetails,
			meta: {
				requiresAuth: true,
			},
		},

	],
});



// WEBPACK FOOTER //
// ./_source/router/index.js